// extracted by mini-css-extract-plugin
export var buttonContent = "_2l-0";
export var centered = "_2l-1";
export var centeredFlex = "_2l-2";
export var errorText = "_2l-3";
export var icon = "_2l-4";
export var iconButtonContent = "_2l-5";
export var monospace = "_2l-6";
export var padded = "_2l-7";